export const TOTALPROFIT = 'TOTALPROFIT'
export const PENDINGISSUSTONEORDERS = 'PENDINGISSUSTONEORDERS'
export const RETURNCUSTFINANCERATIO = 'RETURNCUSTFINANCERATIO'
export const TOTALTURNOVER = 'TOTALTURNOVER'